import networkConnectionTemplate from './networkConnection.html';

export default angular
  .module('main.devices.edit.components.network', [])

  .directive('networkConnection', () => {
    return {
      restrict: 'E',
      template: networkConnectionTemplate,
      scope: {},
      controller: (
        $scope,
        $q,
        utils,
        EditDeviceDataProvider,
        I18nService,
        config,
        $timeout,
      ) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;
        $scope.locale = I18nService.getLocale();
        $scope.loading = true;
        $scope.editWiFi = {};

        const NETWORK_TYPES = config.getConfigByKey('networkTypes');

        angular.extend($scope, {
          gotoCellularTab: gotoCellularTab,
          editWiFiSettings: editWiFiSettings,
          updateNetworkList: updateNetworkList
        });

        init();

        function init() {
          $q.all([
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.deviceCurrentMeasurementsResource.init(),
            $scope.dataProvider.deviceParametersResource.init(),
            $scope.dataProvider.deviceModelResource.init(),
            $scope.dataProvider.deviceNetworkResource.init(),
          ])
            .then(() => {
              initViewModel();
              $scope.loading = false;
              initWatchers();
            });

          $scope.$on('$destroy', () => {
            // Remove modals
            $('#wifi-modal').remove();
          });
        }

        function initWatchers() {
          $scope.$watch('dataProvider.deviceCurrentMeasurementsResource.value', () => {
            if ($scope.dataProvider.deviceCurrentMeasurementsResource.value?.parameters && $scope.dataProvider.deviceParametersResource.value) {
              initViewModel();
            }
          });

          $scope.$watch('editWiFi.networkSsid', (newValue, oldValue) => {
            if (newValue !== null) {
              $scope.editWiFi.manualSsid = null;
            }
          });

          $scope.$watch('editWiFi.manualSsid', (newValue, oldValue) => {
            if (!!newValue) {
              $scope.editWiFi.networkSsid = null;
              $scope.editWiFi.network = null;
            }
          });
        }

        function initViewModel() {
          let measurements = angular.copy($scope.dataProvider.deviceCurrentMeasurementsResource.value?.parameters) || [];
          let deviceParams = angular.copy($scope.dataProvider.deviceParametersResource.value) || [];
          let device = angular.copy($scope.dataProvider.deviceResource.value);

          // Singe source of truth for all network connectivity of current device type
          let networkConnections = angular.copy($scope.dataProvider.deviceNetworkResource.value);
          if (!networkConnections) {
            return;
          }

          // Get current network type from device parameters
          // 1 = Ethernet, 2 = Wi-Fi, 3 = Cellular
          $scope.currentNetwork = measurements.find(m => m.name === 'netType')?.value;
          if ($scope.currentNetwork) {
            let networkType = NETWORK_TYPES.find(el => el.id === parseInt($scope.currentNetwork));
            networkConnections[networkType.name].connected = true;
          }

          $scope.networkConnections = networkConnections;

          // IP address of current active network connection
          $scope.ipAddress = measurements.find(m => m.name === 'ipAddress')?.value;

          networkConnections.wifi && processWifi(device, measurements, deviceParams);
          networkConnections.cellular && processCellular(device, measurements, deviceParams);
          networkConnections.ethernet && processEthernet(device);
        }

        /**
         * Determine Ethernet connection status
         */
        function processEthernet(device) {
          const ethernet = angular.copy($scope.networkConnections.ethernet);

          // We have no direct evidence if device is connected via Ethernet
          ethernet.connected = ethernet.connected || (!$scope.currentNetwork && ethernet.default);
          ethernet.colorBadge = ethernet.connected
            ? (device.connected ? 'green-mark' : 'red-mark')
            : 'grey-mark';

          $scope.networkConnections.ethernet = ethernet;
        }

        /**
         * Determine WiFi connection status
         */
        function processWifi(device, measurements, deviceParams) {
          const wifi = angular.copy($scope.networkConnections.wifi);

          let wifiConnected = measurements.find(m => m.name === 'wifiConnected')?.value; // '0'-no, '1'-yes
          wifi.connected = wifi.connected || wifiConnected === '1' || (!$scope.currentNetwork && wifi.default);

          wifi.ssid = measurements.find(m => m.name === 'wifiSsid')?.value;

          let wifiSecurity = measurements.find(m => m.name === 'wifiSecurity')?.value;
          if (wifiSecurity) {
            wifi.security = utils.deviceParameterToString(
              deviceParams.find(p => p.name === 'wifiSecurity'),
              wifiSecurity,
              null,
              $scope.locale.code);
          }

          wifi.signal = measurements.find(m => m.name === 'wifiSignal')?.value
            || (wifi.connected && device.connected ? '0' : '-90'); // 'no signal' if disconnected

          wifi.signalIcon = utils.getDeviceParameterIcon(
            deviceParams.find(p => p.name === 'wifiSignal'),
            wifi.signal
          );

          wifi.colorBadge = wifi.connected
            ? (device.connected ? 'green-mark' : 'red-mark')
            : 'grey-mark';

          const availableNetworks = measurements.find(m => m.name === 'wifiSsidValues')?.value?.split(',') || [];
          const availableNetworksSecurity = measurements.find(m => m.name === 'wifiSecurityValues')?.value?.split(',') || [];
          const availableNetworksSignals = measurements.find(m => m.name === 'wifiSignalValues')?.value?.split(',') || [];

          wifi.availableNetworks = availableNetworks.map((ssid, i) => ({
            ssid: ssid,
            security: availableNetworksSecurity[i],
            signalIcon: utils.getDeviceParameterIcon(deviceParams.find(p => p.name === 'wifiSignal'), availableNetworksSignals[i]),
          }));

          wifi.autoConnect = measurements.find(m => m.name === 'wifiAutoConnected')?.value === '1';

          $scope.networkConnections.wifi = wifi;
        }

        /**
         * Determine Cellular connection status
         */
        function processCellular(device, measurements, deviceParams) {
          const mobile = angular.copy($scope.networkConnections.cellular);

          mobile.status = measurements.find(m => m.name === 'mobileState')?.value; // '0'-disconnected, '1'-connecting, '2'-connected
          let ccidIndex = measurements.find(m => m.name === 'ccidIndex')?.value;

          // APN Name
          let mobileApn = measurements.find(m => m.name === 'apn' && m.index != null && JSON.stringify(m.index) === JSON.stringify(ccidIndex))?.value
            || measurements.find(m => m.name === 'apn' && m.index == null)?.value
            || measurements.find(m => m.name === 'apn')?.value;
          mobile.apn = utils.deviceParameterToString(
            deviceParams.find(p => p.name === 'apn'),
            mobileApn,
            null,
            $scope.locale.code);

          mobile.signal = measurements.find(m => m.name === 'mobileSignal')?.value || '255'; // 'no signal' by default;
          mobile.signalIcon = utils.getDeviceParameterIcon(
            deviceParams.find(p => p.name === 'mobileSignal'),
            mobile.signal);

          mobile.colorBadge = mobile.status === '2'
            ? (device.connected ? 'green-mark' : 'red-mark')
            : 'grey-mark';

          $scope.networkConnections.cellular = mobile;
        }

        function gotoCellularTab() {
          $scope.dataProvider.activeTab = 'cellular';
        }

        function editWiFiSettings() {
          if ($scope.loading) {
            return;
          }

          $scope.editWiFi = {
            loading: true,
            password: '',
            network: $scope.networkConnections.wifi.availableNetworks.find(n => n.ssid === $scope.networkConnections.wifi.ssid),
            networkSsid: $scope.networkConnections.wifi.ssid,
            autoConnect: $scope.networkConnections.wifi.autoConnect,
          };

          $scope.dataProvider.updateWiFiNetworksList()
            .then(() => {
              $scope.editWiFi.loading = false;
            }, (err) => {
              $scope.editWiFi.loading = false;
              utils.handleApiError(err);
            });

          showWiFiModal();
        }

        function showWiFiModal() {
          $('#wifi-modal')
            .modal({
              closable: true,
              detachable: true,
              autofocus: false,
              onApprove: () => updateWiFiNetwork()
            })
            .modal('show');
        }

        function updateNetworkList() {
          $scope.editWiFi.loading = true;
          $scope.dataProvider.updateWiFiNetworksList()
            .then(() => {
              const deferred = $q.defer();
              $timeout(() => deferred.resolve(), 10000); // wait 10 seconds
              return deferred.promise;
            })
            .then(() => {
              $scope.editWiFi.loading = false;
            }, (err) => {
              $scope.editWiFi.loading = false;
              utils.handleApiError(err);
            });
        }

        function updateWiFiNetwork() {
          $scope.loading = true;
          return $scope.dataProvider.updateWiFiConnection(
            $scope.editWiFi.manualSsid ? $scope.editWiFi.manualSsid : $scope.editWiFi.networkSsid,
            $scope.editWiFi.network.security,
            $scope.editWiFi.password,
            $scope.editWiFi.autoConnect,
          )
            .then(() => {
              $scope.loading = false;
              $('#wifi-modal').modal('hide');
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }
      }
    };
  })
  .name;
